import { render } from "./PreviewPage2-component.vue?vue&type=template&id=85fcd0f8&scoped=true"
import script from "./PreviewPage2-component.vue?vue&type=script&lang=js"
export * from "./PreviewPage2-component.vue?vue&type=script&lang=js"

import "./PreviewPage2-component.vue?vue&type=style&index=0&id=85fcd0f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85fcd0f8"]])

export default __exports__